// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mr-analysis-container {
    padding: 20px;
    font-family: Arial, sans-serif;
}

.filters {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 20px;
    align-items: flex-end;
}

.filter-item {
    display: flex;
    flex-direction: column;
}

.filter-item label {
    font-weight: bold;
    margin-bottom: 4px;
}

.filter-item input,
.filter-item button {
    padding: 8px;
    font-size: 14px;
}

.filter-item button {
    background-color: var(--primary-color);
    color: white;
    border: none;
    cursor: pointer;
}

.filter-item button:hover {
    background-color: var(--primary-color);
}



.error {
    color: red;
    margin-top: 10px;
}

.loading {
    background-color: var(--primary-color);
}

.mr-search-button {
    background-color: var(--primary-color);
    color: white;
    font-weight: bold;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px;
    height: 40px;
    width: 200px;
}

.MR-filter-item {
    display: flex;
    gap: 8px;
    height: 40px;
justify-content: end;}

.MR-table-container {
    overflow-x: auto;
    max-height: 550px;
    margin: 15px 10px;
    width: 100%;
}

.pagination {
    margin-top: 1rem;
    display: flex;
    justify-content: start;
    gap: 8px;
  }
  
  .page-button {
    padding: 6px 12px;
    border: 1px solid #ccc;
    background-color: white;
    cursor: pointer;
    border-radius: 4px;
  }
  
  .page-button.active {
    background-color: var(--primary-color);
    color: white;
    border-color: var(--primary-color);
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/mr-analysis/mr-analysis.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,sCAAsC;AAC1C;;;;AAIA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;AAChB,oBAAoB,CAAC;;AAErB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,YAAY;IACZ,kCAAkC;EACpC","sourcesContent":[".mr-analysis-container {\n    padding: 20px;\n    font-family: Arial, sans-serif;\n}\n\n.filters {\n    display: flex;\n    gap: 16px;\n    flex-wrap: wrap;\n    margin-bottom: 20px;\n    align-items: flex-end;\n}\n\n.filter-item {\n    display: flex;\n    flex-direction: column;\n}\n\n.filter-item label {\n    font-weight: bold;\n    margin-bottom: 4px;\n}\n\n.filter-item input,\n.filter-item button {\n    padding: 8px;\n    font-size: 14px;\n}\n\n.filter-item button {\n    background-color: var(--primary-color);\n    color: white;\n    border: none;\n    cursor: pointer;\n}\n\n.filter-item button:hover {\n    background-color: var(--primary-color);\n}\n\n\n\n.error {\n    color: red;\n    margin-top: 10px;\n}\n\n.loading {\n    background-color: var(--primary-color);\n}\n\n.mr-search-button {\n    background-color: var(--primary-color);\n    color: white;\n    font-weight: bold;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 10px;\n    height: 40px;\n    width: 200px;\n}\n\n.MR-filter-item {\n    display: flex;\n    gap: 8px;\n    height: 40px;\njustify-content: end;}\n\n.MR-table-container {\n    overflow-x: auto;\n    max-height: 550px;\n    margin: 15px 10px;\n    width: 100%;\n}\n\n.pagination {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: start;\n    gap: 8px;\n  }\n  \n  .page-button {\n    padding: 6px 12px;\n    border: 1px solid #ccc;\n    background-color: white;\n    cursor: pointer;\n    border-radius: 4px;\n  }\n  \n  .page-button.active {\n    background-color: var(--primary-color);\n    color: white;\n    border-color: var(--primary-color);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
